module.exports = __webpack_public_path__ + "static/media/subscribe-mobile-back.42862a5d.svg";